<section class="dashboard-empty" role="region" aria-labelledby="dashboard-empty-all-hidden-title">
  <h2 id="dashboard-empty-all-hidden-title" class="dashboard-empty__title">
    {{ 'liveDashboard.empty.allHiddenTitle' | translate }}
  </h2>
  <p class="dashboard-empty__subtitle">{{ 'liveDashboard.empty.allHiddenSubtitle' | translate }}</p>
</section>
